import { VueQueryPlugin } from '@tanstack/vue-query';
import 'virtual:pwa-register/vue';
import { createApp } from 'vue';

import App from '~/App.vue';
import router from '~/router';
import queryClient from '~/store/queryClient';
import '~/styles/main.scss';

import './sentry';

createApp(App)
  .use(router)
  .use(VueQueryPlugin, { queryClient })
  .mount('#app');
